import { SectionLabel } from "@/components/bits";
import { DISCORD_URL } from "@/lib/images";

const SECTIONS = [
  {
    t: "01 // PRODUCTS AND SERVICES",
    content: [
      { type: "p", value: "GZ provides digital software products, including but not limited to game modifications, loaders, configurations, tools, and related digital services (\"Products\" or \"Mods\")." },
      { type: "p", value: "All Products are provided for personal use and are subject to the terms outlined below." },
    ],
  },
  {
    t: "02 // LICENSE & RESELLING RIGHTS",
    content: [
      { type: "p", value: "Upon purchase, GZ grants you a limited, non-exclusive, non-transferable, and revocable license to access and use the purchased Product." },
      { type: "h", value: "Reselling Permission" },
      { type: "p", value: "GZ does not allow customers to resell purchased Products to third parties except under the following conditions:" },
      { type: "ul", value: [
        "The buyer must agree to and follow these Terms of Service.",
        "The original files, branding, and security measures must remain unchanged.",
        "Products may not be cracked, modified, repackaged, or redistributed in a way that removes GZ branding or protections.",
      ] },
      { type: "h", value: "Prohibited Actions — You may not:" },
      { type: "ul", value: [
        "Share, leak, or distribute Products for free.",
        "Reverse engineer, decompile, or modify Products beyond approved reselling purposes.",
        "Attempt to bypass security systems, licensing, or access restrictions.",
        "Claim ownership of GZ Products or services.",
      ] },
    ],
  },
  {
    t: "03 // ACCESS & DELIVERY",
    content: [
      { type: "p", value: "Access to purchased Products may be provided through:" },
      { type: "ul", value: ["Discord roles", "Private channels", "Download links", "Authorized loaders or delivery systems"] },
      { type: "p", value: "GZ reserves the right to suspend or revoke access if a user violates these Terms of Service." },
    ],
  },
  {
    t: "04 // NO GUARANTEES OR WARRANTY",
    content: [
      { type: "p", value: "All Products are provided \"AS IS\" without warranties of any kind. GZ does not guarantee:" },
      { type: "ul", value: [
        "Permanent undetected status.",
        "Compatibility with future game updates.",
        "Protection against account bans, hardware bans, or penalties.",
        "Continuous or uninterrupted functionality.",
      ] },
      { type: "p", value: "By purchasing and using our Products, you acknowledge that usage is at your own risk." },
    ],
  },
  {
    t: "05 // USER CONDUCT",
    content: [
      { type: "p", value: "Users agree not to:" },
      { type: "ul", value: [
        "Submit fraudulent payment disputes or unauthorized chargebacks after receiving Products.",
        "Harass, threaten, or disrespect members, customers, or staff.",
        "Leak, share, or distribute purchased Products.",
        "Abuse support systems or community resources.",
      ] },
    ],
  },
  {
    t: "06 // LIMITATION OF LIABILITY",
    content: [
      { type: "p", value: "To the maximum extent permitted by applicable law, GZ and its owners, staff, and affiliates shall not be responsible for:" },
      { type: "ul", value: ["Account suspensions or bans.", "Hardware restrictions.", "Financial losses.", "Data loss.", "Any direct, indirect, or consequential damages resulting from the use of our Products."] },
    ],
  },
  {
    t: "07 // TERMINATION OF ACCESS",
    content: [
      { type: "p", value: "GZ reserves the right to suspend or terminate user access to Products, services, or community platforms at any time if these Terms are violated. Termination may occur with or without prior notice." },
    ],
  },
  {
    t: "08 // CHANGES TO THESE TERMS",
    content: [
      { type: "p", value: "GZ reserves the right to modify these Terms of Service at any time. Continued participation in the GZ community or continued use of purchased Products after updates means you accept the revised Terms." },
    ],
  },
  {
    t: "09 // ACKNOWLEDGEMENT",
    content: [
      { type: "p", value: "By joining GZ, purchasing a Product, or accessing our services, you confirm that you have read, understood, and agreed to these Terms of Service." },
      { type: "p", value: "GZ reserves the right to enforce these terms to protect our community, products, and services." },
    ],
  },
];

export default function Terms() {
  return (
    <div className="pt-32 pb-28 mx-auto max-w-[900px] px-5 sm:px-8" data-testid="terms-page">
      <SectionLabel>OFFICIAL POLICY</SectionLabel>
      <h1 className="mt-4 font-display text-5xl sm:text-7xl uppercase leading-none">Terms of Service</h1>
      <p className="mt-5 text-white/50">By joining the GZ community, accessing our services, or purchasing any product, you agree to the following Terms of Service.</p>

      <div className="mt-12 space-y-px bg-white/10 border border-white/10">
        {SECTIONS.map((s) => (
          <div key={s.t} className="bg-black p-8">
            <h2 className="font-mono text-sm tracking-[0.2em] text-white mb-4">{s.t}</h2>
            <div className="space-y-3">
              {s.content.map((c, i) => {
                if (c.type === "h") return <p key={i} className="font-mono text-xs tracking-[0.15em] text-white/70 uppercase pt-1">{c.value}</p>;
                if (c.type === "ul") return (
                  <ul key={i} className="space-y-2 pl-1">
                    {c.value.map((li, j) => (
                      <li key={j} className="flex gap-3 text-white/55 leading-relaxed"><span className="text-white/40 mt-1">/</span>{li}</li>
                    ))}
                  </ul>
                );
                return <p key={i} className="text-white/55 leading-relaxed">{c.value}</p>;
              })}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 text-center font-mono text-xs tracking-[0.2em] text-white/40">
        QUESTIONS? <a href={DISCORD_URL} target="_blank" rel="noreferrer" className="text-white underline">discord.gg/injectd</a>
      </div>
    </div>
  );
}
